import { AfpantPantedokument } from "@/components/AfpantPantedokument/AfpantPantedokument";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/",
)({
  loader: async ({ params }) => {
    const { orgNumber, pantedokumentId } = params;

    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"].pantedokument[":pantedokumentId"].$get({
      param: {
        orgNumber,
        pantedokumentId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch pantedokument message");
    }

    return {
      pantedokument: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Pantedokument | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { orgNumber } = Route.useParams();
  const { pantedokument } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>Pantedokument</DocumentTitle>

      <AfpantPantedokument
        orgNumber={orgNumber}
        pantedokument={pantedokument.pantedokument}
        responses={pantedokument.afpant_pantedokument_response}
      />
    </>
  );
}
